export const TRY_FETCH_ACTIVITIES = 'tryFetchActivities';
export const SET_ACTIVITIES = 'setActivities';
